import { BooleanType } from '@convergence/types';
import { valueFromTreeAndPath } from '../util';
import { AnalysisInputProps } from '../types';

export function AnalysisBoolInput(props: AnalysisInputProps<BooleanType>) {
  const value = valueFromTreeAndPath<boolean>(props.tree, props.propertyPath);

  return (
    <div className="py-2">
      <label className="inline-flex items-center gap-2 align-middle">
        <span className="flex flex-col justify-center">{props.name}</span>
        <input
          type="checkbox"
          className=""
          onChange={(e) => {
            props.onChange(props.propertyPath, e.target.checked);
          }}
          checked={value}
        />
      </label>
    </div>
  );
}
